import { useLocation } from 'react-router-dom';

// The assistant's deep-link filters for a list page, carried in router state.
export const useAssistantFilters = () => useLocation().state?.assistantFilters;
